import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Urls } from "../../../utils/constant";

import { useApi } from "../apiCall/useApi";

import useFullPageLoader from "../Common/PageLoader/useFullPageLoader";

import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";

import {
  setDoctorComboList,
  setPatientComboList,
  setReviewList,
} from "../../reducers/Review/Review.reducer";
import {
  getDoctorList,
  getPatientList,
} from "../../selectors/Review/Review.selector";

const COLUMN_LIST = [
  {
    field: "sr_no",
    headerName: "sr. no.",
    flex: 1,
  },
  {
    field: "doctor_name",
    headerName: "Doctor Name",

    flex: 2,
  },
  {
    field: "patient_name",
    headerName: "Patient Name",
    flex: 2,
  },
  {
    field: "date_time",
    headerName: "Date & Time",
    flex: 2,
  },
  {
    field: "rating",
    headerName: "Ratings",
    flex: 1,
  },
  {
    field: "comment",
    headerName: "Comment",
    flex: 2,
  },

  {
    field: "is_recommend_val",
    headerName: "Recommend",
    flex: 1,
  },
  {
    field: "status_val",
    headerName: "Status",
    flex: 1,
  },
];

const StatusList = [
  { id: 1, label: "active" },
  { id: 2, label: "In-Active" },
];

export default function useReview() {
  const dispatch = useDispatch();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [DoctorId, setDoctorId] = useState("");
  const [PatientId, setPatientId] = useState("");
  const [status, setStatus] = useState(1);
  const doctorList = useSelector(getDoctorList);
  const patientList = useSelector(getPatientList);

  const fetchReviewList = useCallback(
    async ({ current_page = 1, row_count }) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());
        const StatusVal = status === "All" ? 0 : status;

        const { data } = await apiPost({
          url: Urls.reviewGet(),
          data: {
            doctor_id: DoctorId,
            patient_id: PatientId,
            status: StatusVal,
            page_size: row_count,
            current_page: current_page,
          },
        });
        // setting list to reducer
        dispatch(setReviewList(data));
        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
      }
    },
    [loading, status, DoctorId, PatientId]
  );

  const fetchDoctorComboList = useCallback(async () => {
    try {
      const { data } = await apiPost({
        url: Urls.getDoctorCombo(),
        data: {},
      });
      // setting list to reducer

      dispatch(setDoctorComboList(data.data));
    } catch (err) {
      console.log(err);
    }
  }, [DoctorId]);
  const fetchPatientComboList = useCallback(async () => {
    try {
      const { data } = await apiPost({
        url: Urls.getPatientCombo(),
        data: {},
      });
      // setting list to reducer

      dispatch(setPatientComboList(data.data));
    } catch (err) {
      console.log(err);
    }
  }, [PatientId]);

  const finddoctorFromLabel = useCallback(
    (value) => {
      const selectedDoctorId = value
        ? doctorList.find((item) => item.label === value)?.id
        : null;
      setDoctorId(selectedDoctorId);

      return selectedDoctorId;
    },
    [doctorList]
  );

  const findpatientFromLabel = useCallback(
    (value) => {
      const selectedPatientId = value
        ? patientList.find((item) => item.label === value)?.id
        : null;
      setPatientId(selectedPatientId);
      return selectedPatientId;
    },
    [patientList]
  );

  const handleStatusChange = useCallback((e) => {
    setStatus(e.target.value);
  }, []);

  return {
    gridHeaders: COLUMN_LIST,
    loading,
    loader,
    status,
    StatusList,
    DoctorId,
    PatientId,
    finddoctorFromLabel,
    findpatientFromLabel,
    handleStatusChange,
    fetchReviewList,
    fetchDoctorComboList,
    fetchPatientComboList,
  };
}
